import { Scene } from "phaser";

// The HUD scene is the scene that shows the points and the remaining time.
export class InfoScene extends Scene {
    
    constructor() {
        super("InfoScene");
    }

    init(data) {
        //this.cameras.main.fadeIn(500, 0, 0, 0);
    }

    create() {
        this.userNameText = this.add.text(this.scale.width/2, this.scale.width/2, `InfoScene`).setOrigin(0.5);
    }
}